export const prospects_displayed_columns_locale = {
  companyName: "Company name",
  status: "Status",
  nextContactTimestamp: "Contact",
  contactPerson: "Contact person",
  phoneNumber: "Telephone number",
};
